let doit = null;

const adjust = () => {
  const contentsTexts = document.getElementsByClassName('contents-texts');
  const contentsImgs = document.getElementsByClassName('contents-img');
  const contents = document.getElementsByClassName('contents');
  const entryCommon = document.getElementsByClassName('entry-common');
  const wW = window.innerWidth;

  // 以下ある1日のスケジュール
  const oneday = document.getElementById('oneday');
  const ballonsLeft = document.getElementById('ballonsLeft');
  const times = document.getElementById('times');
  const timesOuter = document.getElementsByClassName('times-outer');

  // ページャー
  const interviewPager = document.getElementById('interviewPager');

  // h1のbrで出来るスペースを削除
  const catchCopy = document.getElementById('catchCopy');
  const regEx = / /g;
  const catchCopyText = catchCopy.innerText;
  const regExCatchCopy = catchCopyText.replace(regEx, '');
  const span = document.createElement('span');

  clearTimeout(doit);

  doit = setTimeout(() => {
    if (wW <= 949) {
      for (let i = 0, l = contentsTexts.length; i < (l - 1); i++) {
        contents[i + 1].removeAttribute('style');
      }

      // entry
      const contentsTextsLen = contentsTexts.length;
      entryCommon[0].removeAttribute('style');

      // ある1日のスケジュールがある場合
      if (oneday) {
        oneday.removeAttribute('style');

        times.removeAttribute('style');

        for (let i = 0, l = timesOuter.length; i < l; i++) {
          const ballonObj = document.getElementById('ballons-ballon--sm' + i);

          timesOuter[i].style.marginBottom = ballonObj.clientHeight - 54 + 20 + 'px';
        }
      } else {
        interviewPager.removeAttribute('style');
      }

      // h1のbrで出来るスペースを削除
      span.textContent = regExCatchCopy;
      catchCopy.textContent = '';
      catchCopy.appendChild(span);

    } else {
      for (let i = 0, l = contentsTexts.length; i < (l - 1); i++) {
        contents[i + 1].style.marginTop = (contentsTexts[i].clientHeight - contentsImgs[i].clientHeight / 2) + 100 + 'px';
      }

      // entry
      const contentsTextsLen = contentsTexts.length;

      // ある1日のスケジュールがある場合
      if (oneday) {
        oneday.style.marginTop = (contentsTexts[contentsTextsLen - 1].clientHeight - contentsImgs[contentsTextsLen - 1].clientHeight / 2) + 120 + 'px';

        for (let i = 0, l = timesOuter.length; i < l; i++) {
          const ballonObj = document.getElementById('ballons-ballon--' + i);
          const ballonNextObj = document.getElementById('ballons-ballon--' + (i + 1));

          timesOuter[i].style.marginBottom = ballonObj.clientHeight - 70 - 1 + 'px';

          if (i === 0) {
            ballonNextObj.style.marginTop = ballonObj.clientHeight - 1 + 'px';
          } else {
            if (ballonNextObj) {
              ballonNextObj.style.marginTop = ballonObj.clientHeight - (1 * 2) + 'px';
            }
          }
        }

        times.style.height = ballonsLeft.offsetHeight + 'px';
      } else {
        interviewPager.style.marginTop = (contentsTexts[contentsTextsLen - 1].clientHeight - contentsImgs[contentsTextsLen - 1].clientHeight / 2) + 120 + 'px';
      }
    }
  }, 200);
};

window.addEventListener('DOMContentLoaded', adjust, false);
window.addEventListener('resize', adjust, false);